import { inject, injectable } from 'inversify'
import { TYPES } from '@/libs/di/types'

import type { AccountUsecase } from '@/apis/usecases'
import type { AccountRepository } from '@/apis/usecases/dataAccesses'

@injectable()
export class AccountInteractor implements AccountUsecase {
  @inject(TYPES.AccountRepository)
  private _accountRepository: AccountRepository

  public async postLogout() {
    await this._accountRepository.postLogout()
  }

  public updateSession() {
    return this._accountRepository.updateSession()
  }

  public requestLogin(payload: { email: string; password: string }) {
    return this._accountRepository.requestLogin(payload)
  }
}
